import api from '../api';

export const getCreationFormApi = () => api.get('/Asset/CreationForm').then((res) => res.data);

export const createAssetsApi = (params) => api.post('/Assets/Batch', params).then((res) => res);

export const updateAssetsApi = (params) => api.put('/Assets/Batch', params).then((res) => res);
